export const accountingRoutes = {
  cashbook: '/ke-toan/so-quy'
};
